import React, { useEffect, useState } from 'react'
import $t from '../../../i18n'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { planTypes } from '../../../consts'
import getSymbolFromCurrency from 'currency-symbol-map'
import { Spin } from 'antd'
import config from '../../../config.json'
import Page from '../../common/Page'
import { t } from '@transifex/native'

import './account.css'

export const planImage = image_name => {
  return {
    uri: config.gcpStorageUrl + '/app/' + image_name + '_Plan_Screen.png',
  }
}

const Account = () => {
  const mySubscriptions = useSelector(
    state => state.payment.my_subscriptions?.[0]
  )
  const accountData = useSelector(state => state.account.accountData)
  const [isLoadingAccount, setLoadingAccount] = useState(true)
  const planDetails = mySubscriptions?.plan_details

  useEffect(() => {
    if (Object.keys(accountData).length !== 0) {
      setLoadingAccount(false)
    }
  }, [accountData])

  return (
    <Page
      className="account-container"
      title={$t('account_plans.account_status')}
    >
      {isLoadingAccount ? (
        <div className="spinnerWrapper">
          <Spin size="large" />
        </div>
      ) : null}
      {!isLoadingAccount && (
        <div className="account-content">
          <div className="family-membership-content">
            <div className="family-col1">
              <div className="family-col-content">
                <span>{t(mySubscriptions?.plan_name)}</span>
              </div>
              {mySubscriptions?.plan_details?.image_name && (
                <div className="family-content-image">
                  <img
                    src={
                      planImage(mySubscriptions?.plan_details?.image_name).uri
                    }
                    alt="user"
                  />
                </div>
              )}
            </div>
            <div className="divider"></div>

            <div className="family-col2">
              {!planDetails?.is_without_payment && (
                <span>
                  {`${$t('account_plans.purchasedOn')} ${moment(
                    mySubscriptions?.created_at
                  ).format(config.planDateFormat)}`}
                </span>
              )}
              {mySubscriptions?.expire_date &&
                planDetails?.type !== planTypes.ONE_TIME &&
                planDetails?.type !== planTypes.BNPL &&
                !planDetails?.is_without_payment && (
                  <span>
                    {`${$t('account_plans.nextBilling')} ${moment(
                      mySubscriptions?.expire_date
                    ).format(config.planDateFormat)}`}
                  </span>
                )}
              {planDetails?.is_without_payment && (
                <span>
                  {`${$t('profile.validUntil')} ${moment(
                    mySubscriptions?.expire_date
                  ).format(config.planDateFormat)}`}
                </span>
              )}
              {planDetails?.type === planTypes.BNPL && (
                <a href={config.planSubscriptionURL} target="_blank">
                  {'Subscription Terms of Use'}
                </a>
              )}
            </div>
          </div>
          <div className="doctor-visit-content">
            <div className="doctor-visit-box1">
              <h3>{$t('account_plans.doctor_visits')}</h3>
              <p className="number-of-visits">
                {accountData?.visits} {$t('account_plans.visits')}
              </p>
              {accountData?.no_shows_dates && (
                <p className="missed-appointments">
                  {$t('account_plans.noShowNotePart1')}
                  {$t('account_plans.noShowNoteDates', {
                    x: accountData?.no_shows_dates
                      ? accountData?.no_shows_dates.length
                      : 0,
                  })}
                  {accountData.no_shows_dates.length > 1 ? 's' : ''}
                  {$t('account_plans.noShowNotePart2')}
                </p>
              )}
              {planDetails?.terms && <li>{t(planDetails?.terms)}</li>}
            </div>
            {accountData?.used_drugs_yearly_cents && (
              <>
                <div className="divider"></div>
                <div className="doctor-visit-box2">
                  <h3 className="drug-reimbursement-title">
                    {$t('account_plans.drug_reimbursement')}
                  </h3>{' '}
                  <span>
                    {getSymbolFromCurrency(
                      accountData?.used_drugs_yearly_cents?.currency
                    )}
                    {accountData?.used_drugs_yearly_cents?.amount / 100}
                  </span>
                </div>
              </>
            )}

            <div
              className={['divider', 'doctor-visit-divider'].join(' ')}
            ></div>

            <div className="doctor-visit-box3">
              <h3 className="referrals-title">
                {$t('account_plans.referrals')}
              </h3>
              <span className="number-of-referrals">
                {$t('account_plans.total_of')} {accountData?.referrals}
              </span>
            </div>

            {/* <div className="divider"></div>
              {accountData?.total_saving_yearly_cents && (
                <div className="doctor-visit-box4">
                  <h3 className="total-savings">
                    {$t('account_plans.total_savings_of')}{' '}
                    {getSymbolFromCurrency(
                      accountData?.total_saving_yearly_cents?.currency
                    )}
                    {accountData?.total_saving_yearly_cents?.amount / 100}
                  </h3>
                </div>
              )} */}
          </div>
        </div>
      )}
    </Page>
  )
}
export default Account
